import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
    useGetMapperListMutation,
    useGetMapperMutation,
} from '../../Redux/Admin_Tasks/DataMapperSlice'
import IndividualMapper from './IndividualMapper'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from "../../Hooks/useTitleContext";


declare let window: any
const UnicornApp = window.unicornInstance as any

function DataMapperTool() {

    const { setTitle } = useTitleContext();
    setTitle("DataMapper");

    const [MapperList, setMapperList] = useState([] as any)
    const [statusCode, setStatusCode] = useState(0)
    const [showIndividualMapper, setShowIndividualMapper] = useState(false)
    const [selectedMapper, setSelectedMapper] = useState({
        Key: '',
        value: '',
        description: '',
        help: null as string | null,
        Mapper: null,
        Columns: [] as string[],
    })
    const [responseMapperList, { data: response, error, isLoading, isSuccess, isError }] =
        useGetMapperListMutation()
    const [getMapper, { isLoading: IM_isLoading }] = useGetMapperMutation()
    useEffect(() => {
        responseMapperList()
    }, [responseMapperList])

    useEffect(() => {
        if (!isLoading) {
            if (isSuccess && response) {
                setMapperList(response.data)
            } else if (isError && error) {
                FoundationsGenericToaster('error', 'Could Not Load Mappers')
            }
        }
    }, [isLoading, isSuccess, isError, response, error])

    const ManageMapperClicked = async (
        Key: string,
        value: string,
        description: string,
        help: string | null
    ) => {
        const GetIndividualMapper = await getMapper({ key: Key, action: 'ButtonAction', data: [] })
        if (!IM_isLoading) {
            try {
                if (GetIndividualMapper?.data?.statusMessage?.toLowerCase() === 'success') {
                    var Mapper = GetIndividualMapper.data.data;
                    const attributeList = GetIndividualMapper.data.data.Value?.AttributeList;
                    const Columns =
                        attributeList && attributeList[0]?.Prop0
                            ? attributeList[0].Prop0.split(',').slice(1)
                            : [];
                    setSelectedMapper({ Key, value, description, help, Mapper, Columns });
                    setShowIndividualMapper(true);
                } else {
                    throw new Error('Could Not Load Mapper');
                }
            } catch (error) {                                   
                // Log the error for debugging
                FoundationsGenericToaster('error', 'Could Not Load Mapper')
            }
        }
    }

    const GotoMapperList = () => {
        setShowIndividualMapper(false)
    }

    if (showIndividualMapper && selectedMapper) {
        return (
            <IndividualMapper
                Key={selectedMapper.Key}
                value={selectedMapper.value}
                description={selectedMapper.description}
                help={selectedMapper.help}
                defaultMapper={selectedMapper.Mapper}
                Columns={selectedMapper.Columns}
                GotoMapperList={GotoMapperList}
            />
        )
    } else {
        return (
            <div id="datamapper_tool">
                <div>
                    <div className="float-right margin-top-small">
                        <a id="link_backto_admin_tasks" href="index.html#AdminTasks">
                            &laquo; Back to Admin Tasks
                        </a>
                    </div>
                    <div className="header">Data Mappings</div>
                    <div className="padding-top-medium"></div>
                    <Skeleton loading={isLoading} height="300px" width="100%">
                    <table className="admin-table">
                        <tr className="admin-row-header">
                            <td style={{ width: '30%' }}>Mapping Name</td>
                            <td style={{ width: '50%' }}>Mapping Description</td>
                            <td style={{ width: '15%' }}>Actions</td>
                        </tr>
                        {!isLoading &&
                            MapperList.length > 0 &&
                            MapperList.map(
                                (mapper: {
                                    Value: string | null
                                    Description: string | null
                                    key: number
                                    HelpText: string | null
                                }) => (
                                    <tr className="admin-row-data">
                                        <td>{mapper.Value}</td>
                                        <td>{mapper.Description}</td>
                                        <td className="text-center">
                                            <span
                                                data-key={mapper.key}
                                                data-value={mapper.Value}
                                                data-description={mapper.Description}
                                                data-help={mapper.HelpText}
                                                className="btn-custom btn-default btn-sm"
                                                onClick={() =>
                                                    ManageMapperClicked(
                                                        mapper.key.toString(),
                                                        mapper.Value ? mapper.Value : '',
                                                        mapper.Description
                                                            ? mapper.Description
                                                            : '',
                                                        mapper.HelpText
                                                    )
                                                }
                                            >
                                                {' '}
                                                Manage Mapper
                                            </span>
                                        </td>
                                    </tr>
                                )
                            )}
                        {!isLoading && MapperList.length === 0 && (
                            <tr>
                                <td colSpan={4}>No data mappers found.</td>
                            </tr>
                        )}
                    </table>
                    </Skeleton>
                </div>
            </div>
        )
    }
}

export default DataMapperTool
